/* CANFOTO / GDX — ETAP 2
   AM-V2 R1A+B+C — VERSIONED ATOMIC PRODUCT CACHE SHADOW CONSUMER
   R2 EXTENSION = VALIDATED CURRENT MAY BECOME VISIBLE SETUP OWNER
   FAIL-CLOSE FALLBACK = FROZEN_CANONICAL_SNAPSHOT

   Reads server-rendered Shopify JSON metafields:
   - canfoto_nora.profile_v2_current
   - canfoto_nora.profile_v2_previous
   - legacy canfoto_nora.materialized_profile_v2 (migration read only)

   NO visible DOM / score / rank / F-P / setup truth / commerce / share mutation.
*/
(()=>{
'use strict';
const VERSION='CANFOTO-ETAP2-AMV2-R1ABC-VERSIONED-ATOMIC-CACHE-SHADOW-V1';
const R2_VERSION='CANFOTO-ETAP2-AMV2-R2-VALIDATED-CACHE-VISIBLE-OWNER-V1';
const SCHEMA='CANFOTO_NORA_PRODUCT_PROFILE_V2';
const clean=v=>String(v??'').replace(/\s+/g,' ').trim();
const clone=v=>{try{return structuredClone(v)}catch(_){return JSON.parse(JSON.stringify(v))}};
const deepFreeze=v=>{
  if(!v||typeof v!=='object'||Object.isFrozen(v))return v;
  Object.keys(v).forEach(k=>deepFreeze(v[k]));
  return Object.freeze(v);
};
function parseContext(){
  const el=document.getElementById('canfotoNoraMaterializedCacheV2Context');
  if(!el)return null;
  try{return JSON.parse(el.textContent||'{}')}catch(error){return {__parseError:clean(error?.message||error)}};
}
function parseProfile(raw){
  if(raw==null||raw==='')return null;
  if(typeof raw==='string'){
    const s=raw.trim(); if(!s)return null;
    try{return JSON.parse(s)}catch(_){return null}
  }
  return raw&&typeof raw==='object'?raw:null;
}
function hex64(v){return /^[0-9a-f]{64}$/i.test(clean(v))}
function top5Of(p){return Array.isArray(p?.setupProjection?.top5)?p.setupProjection.top5:[]}
function setupId(row){return clean(row?.setupRecordId||row?.canonicalSetupRecordId||row?.canonicalDto?.setupRecordId)}
function isNotAdmitted(profile){return clean(profile?.status)==='NOT_ADMITTED'&&clean(profile?.cache?.activationState)==='ACTIVE'}
function validate(profile,ctx,{legacy=false}={}){
  if(!profile)return {present:false,ok:false,checks:{profilePresent:false},failedChecks:['profilePresent']};
  const top5=top5Of(profile), ids=top5.map(setupId).filter(Boolean);
  const pHandle=clean(profile?.product?.handle), pId=clean(profile?.product?.id);
  const expectedHandle=clean(ctx?.productHandle), expectedId=clean(ctx?.productId);
  const schemaVersion=clean(profile?.schemaVersion);
  const checks={
    profilePresent:true,
    schemaExact:clean(profile?.schema)===SCHEMA,
    schemaVersionAllowed:legacy?['2.0.0','2.1.0'].includes(schemaVersion):schemaVersion==='2.1.0',
    statusReady:clean(profile?.status)==='READY',
    validationReady:legacy?true:clean(profile?.validation?.status)==='VALIDATED',
    activationActive:clean(profile?.cache?.activationState)==='ACTIVE',
    productHandleExact:!!expectedHandle&&pHandle===expectedHandle,
    productIdExact:!pId||!expectedId||pId===expectedId,
    engineSupported:['GDX_PANEL_LED_V4','GDX_COB_LED_V5'].includes(clean(profile?.admission?.engineOwner)),
    noraReady:profile?.admission?.noraReady===true,
    top5ExactlyFive:top5.length===5,
    top5SetupIdsPresent:ids.length===5,
    top5UniqueSetupIds:ids.length===5&&new Set(ids).size===5,
    top5RankSequential:top5.every((x,i)=>Number(x?.rank)===i+1),
    everySetupProductContextExact:top5.every(x=>{
      const h=clean(x?.productHandle||x?.canonicalDto?.product?.handle||x?.canonicalDto?.product?.key);
      return !h||h===expectedHandle;
    }),
    everyCanonicalDtoIdExact:top5.every(x=>{
      const rowId=setupId(x);
      const dtoId=clean(x?.canonicalDto?.setupRecordId);
      return !!rowId&&!!dtoId&&rowId===dtoId;
    }),
    everyV27Ready:top5.every(x=>
      x?.sharedV27Projection?.readyForOffDomV27===true &&
      clean(x?.sharedV27Projection?.setupRecordId)===setupId(x)
    ),
    sourceInputFingerprint:hex64(profile?.source?.inputFingerprint),
    profileFingerprint:hex64(profile?.cache?.profileFingerprint)
  };
  const failedChecks=Object.entries(checks).filter(([,v])=>v!==true).map(([k])=>k);
  return {present:true,ok:failedChecks.length===0,checks,failedChecks,profileFingerprint:clean(profile?.cache?.profileFingerprint),setupIds:ids};
}
const context=parseContext();
const current=parseProfile(context?.currentProfile);
const previous=parseProfile(context?.previousProfile);
const legacy=parseProfile(context?.legacyProfile);
const handle=clean(context?.productHandle), productId=clean(context?.productId);
const state={
  version:VERSION,schema:SCHEMA,mode:'SHADOW_ONLY_R1ABC',status:'BOOTING',ready:false,
  productHandle:handle,productId,currentPresent:!!current,previousPresent:!!previous,legacyPresent:!!legacy,
  current:null,previous:null,legacy:null,activeShadowSource:'NONE',failedChecks:[],
  guards:{visibleDomMutation:'NONE',scoreMutation:'NONE',rankingMutation:'NONE',fpMutation:'NONE',setupTruthMutation:'NONE',commerceMutation:'NONE',shareMutation:'NONE',currentFrozenOwnerMutation:'NONE'}
};
function publish(){
  if(!context){state.status='HOLD_CONTEXT_MISSING';state.failedChecks=['contextPresent'];}
  else if(context.__parseError){state.status='HOLD_CONTEXT_PARSE';state.failedChecks=['contextParse'];}
  else{
    state.current=validate(current,context);
    state.previous=previous?validate(previous,context):{present:false,ok:false,checks:{profilePresent:false},failedChecks:['profilePresent']};
    state.legacy=legacy?validate(legacy,context,{legacy:true}):{present:false,ok:false,checks:{profilePresent:false},failedChecks:['profilePresent']};
    if(current){
      state.activeShadowSource='CURRENT';
      if(isNotAdmitted(current)){
        state.status='NOT_ADMITTED_SHADOW_CURRENT';
        state.ready=true;
        state.failedChecks=[];
      }else{
        state.status=state.current.ok?'READY_SHADOW_CURRENT':'HOLD_INVALID_CURRENT';
        state.ready=state.current.ok;
        state.failedChecks=state.current.failedChecks.slice();
      }
    }else if(legacy){
      state.activeShadowSource='LEGACY_MIGRATION_READ';
      state.status=state.legacy.ok?'READY_SHADOW_LEGACY':'HOLD_INVALID_LEGACY';
      state.ready=state.legacy.ok;
      state.failedChecks=state.legacy.failedChecks.slice();
    }else{
      state.activeShadowSource='NONE';
      state.status='EMPTY_NO_PROFILE';
      state.ready=true;
      state.failedChecks=[];
    }
  }
  const r2Eligible=(engineOwner)=>{
    const expectedEngine=clean(engineOwner);
    return state.status==='READY_SHADOW_CURRENT' &&
      state.current?.ok===true &&
      clean(current?.admission?.engineOwner)===expectedEngine &&
      current?.admission?.noraReady===true &&
      clean(current?.setupProjection?.state)==='READY' &&
      top5Of(current).length===5;
  };
  const api=deepFreeze({
    version:VERSION,schema:SCHEMA,mode:'SHADOW_ONLY_R1ABC',
    r2Version:R2_VERSION,
    getState:()=>deepFreeze(clone(state)),
    getCurrent:()=>current?deepFreeze(clone(current)):null,
    getPrevious:()=>previous?deepFreeze(clone(previous)):null,
    getLegacy:()=>legacy?deepFreeze(clone(legacy)):null,
    getProfile:()=>current?deepFreeze(clone(current)):(legacy?deepFreeze(clone(legacy)):null),
    hasReadyCurrent:()=>state.status==='READY_SHADOW_CURRENT',
    isCurrentNotAdmitted:()=>state.status==='NOT_ADMITTED_SHADOW_CURRENT',
    hasAnyReadyShadow:()=>state.ready===true&&(/^READY_SHADOW_/.test(state.status)||state.status==='NOT_ADMITTED_SHADOW_CURRENT'),
    canCutoverVisibleOwner:(engineOwner)=>r2Eligible(engineOwner),
    getR2Candidate:(engineOwner)=>r2Eligible(engineOwner)?deepFreeze(clone(current)):null,
    getR2SetupIds:(engineOwner)=>r2Eligible(engineOwner)?top5Of(current).map(setupId):[]
  });
  const r2Api=deepFreeze({
    version:R2_VERSION,
    mode:'VALIDATED_CACHE_VISIBLE_OWNER_CANDIDATE',
    fallbackOwner:'FROZEN_CANONICAL_SNAPSHOT',
    canCutoverVisibleOwner:(engineOwner)=>r2Eligible(engineOwner),
    getCandidate:(engineOwner)=>r2Eligible(engineOwner)?deepFreeze(clone(current)):null,
    getSetupIds:(engineOwner)=>r2Eligible(engineOwner)?top5Of(current).map(setupId):[],
    getState:()=>deepFreeze(clone(state))
  });
  window.CANFOTO_NORA_MATERIALIZED_CACHE_V2=api;
  window.CANFOTO_AMV2_R1ABC_SHADOW=api;
  window.CANFOTO_AMV2_R2_VISIBLE_OWNER=r2Api;
  window.dispatchEvent(new CustomEvent('canfoto:amv2-r1abc-shadow-ready',{detail:{version:VERSION,status:state.status,productHandle:handle,activeShadowSource:state.activeShadowSource}}));
  window.dispatchEvent(new CustomEvent('canfoto:amv2-r2-visible-owner-candidate-ready',{detail:{version:R2_VERSION,status:state.status,productHandle:handle,eligiblePanel:r2Eligible('GDX_PANEL_LED_V4'),eligibleCob:r2Eligible('GDX_COB_LED_V5')}}));
}
publish();
})();
